import { render, staticRenderFns } from "./PaginationCardList.vue?vue&type=template&id=bc528874&scoped=true&"
import script from "./PaginationCardList.vue?vue&type=script&lang=js&"
export * from "./PaginationCardList.vue?vue&type=script&lang=js&"
import style0 from "./PaginationCardList.vue?vue&type=style&index=0&id=bc528874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc528874",
  null
  
)

export default component.exports